<template>
  <v-container>
    <v-btn @click="goToMassTorts">Mass-Torts</v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    goToMassTorts() {
      this.$router.push({ name: "MassTorts" });
    }
  },
  created() {}
};
</script>

<style></style>
